import React from 'react';
import {DevicePhoneMobileIcon, UserCircleIcon} from '@heroicons/react/24/outline';

import Register from '../Auth/Register';
import {RegisterIcon} from '../Auth/RegisterIcon';
import EmailIcon from '../img/email.svg';
import PasswordIcon from '../img/password.svg';

// The MUI `FaceTwoTone` and `LocalPhoneTwoTone` glyphs are replaced by
// heroicons at the same 80px box, which is the only icon family the migrated
// surfaces use.
const RegisterScreen = () => (
  <Register
    title="Let's get started!"
    nameHeader={
      <>
        <RegisterIcon>
          <UserCircleIcon
            className="mx-auto size-20 text-(--compass-primary)"
            aria-hidden="true"
          />
        </RegisterIcon>
        <h3 className="mb-2 text-2xl font-semibold">What's your name?</h3>
      </>
    }
    emailHeader={
      <>
        <RegisterIcon>
          <img src={EmailIcon} height={60} width={60} alt="" aria-hidden="true" />
        </RegisterIcon>
        <h3 className="mb-2 text-2xl font-semibold">What's your email address?</h3>
        <p className="mb-4">We use this to make an account</p>
      </>
    }
    passwordHeader={
      <>
        <RegisterIcon>
          <img src={PasswordIcon} height={60} width={60} alt="" aria-hidden="true" />
        </RegisterIcon>
        <h3 className="mb-2 text-2xl font-semibold">Create a password</h3>
      </>
    }
    phoneHeader={
      <>
        <RegisterIcon>
          <DevicePhoneMobileIcon
            className="mx-auto size-20 text-(--compass-primary)"
            aria-hidden="true"
          />
        </RegisterIcon>
        <h3 className="mb-2 text-2xl font-semibold">What's your mobile number? (Optional)</h3>
        <p className="mb-4">
          We use this to send you helpful notifications from Compass. You can switch these
          notifications off later in your account settings.
        </p>
      </>
    }
    showPhoneField={true}
  />
);

export default RegisterScreen;
